import React, { useEffect, useState } from 'react'

import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useNavigate } from "react-router-dom";


const GroupCreate = ({ close }) => {
    const [formData, setFormData] = useState({
        plan_id: "",
        group_name: "",
        customers_count: "",
    });
    const [plan, SetPlan] = useState([])
    const navigate = useNavigate();
    const [validation, setvalidation] = useState([])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(
                "public/api/plans/list",
                { headers: { Authorization: `Bearer ${token}` } }
            )
           
            SetPlan(response.data)
        } catch (error) {
            console.error("Error:", error);
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");

            const response = await axios.post(
                "public/api/groups",
                formData,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            toast.success(response.data.message);
            close()

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm");
            }
            setvalidation(error.response.data);
        }
    };

    return (
        <div className='p-6'>
            {/* <div className="col-span-3 bg-indigo-400  p-6">
                <div className="max-w-7xl mx-auto md:px-8 flex justify-between items-center">
                    <dt className="text-xl text-white font-medium leading-6">CREATE GROUP</dt>
                    <button
                        onClick={close}
                        className="text-gray-500 hover:text-gray-700 focus:outline-none"
                    >
                        <svg
                            className="w-6 h-6"
                            fill="none"
                            stroke="white"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                            ></path>
                        </svg>
                    </button>
                </div>
            </div> */}

            {/* <div className="max-w-7xl  p-6 bg-gray-100">
                <div className="md:grid md:gap-6">
                    <div className=" md:col-span-2">
                        <form
                            onSubmit={handleSubmit}
                        >
                            <div className="shadow overflow-hidden sm:rounded-md">
                                <div className="px-4 py-5 bg-white sm:p-6">
                                    <div className="grid grid-cols-6 gap-6">
                                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                            <label
                                                htmlFor="plan_id"
                                                className="block text-sm font-medium leading-6 text-gray-900"
                                            >
                                                Plan
                                            </label>
                                            <div className="mt-2">
                                                <select
                                                    id="plan_id"
                                                    name="plan_id"
                                                    value={formData.plan_id}
                                                    onChange={handleChange}
                                                    autoComplete="plan_id"
                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                >
                                                    <option value={""}>Select Plan</option>
                                                    {plan?.map((type) => (
                                                        <option key={type.id} value={type.id}>
                                                            {type.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                             <p className="text-red-600 text-sm mt-1">
                                                    {validation.errors?.plan_id}
                                                </p>
                                        </div>
                                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                            <label
                                                htmlFor="amount"
                                                className="block text-sm font-medium leading-6 text-gray-900"
                                            >
                                                Group Name
                                            </label>
                                            <div className="mt-2">
                                                <input
                                                    id="group_name"
                                                    name="group_name"
                                                    type="text"
                                                    placeholder="Group Name"
                                                    value={formData.group_name}
                                                    onChange={handleChange}
                                                    autoComplete="amount"
                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                />
                                                <p className="text-red-600 text-sm mt-1">
                                                    {validation.data?.group_name}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                            <label
                                                htmlFor="amount"
                                                className="block text-sm font-medium leading-6 text-gray-900"
                                            >
                                                Customer Count
                                            </label>
                                            <div className="mt-2">
                                                <input
                                                    id="customers_count"
                                                    name="customers_count"
                                                    type="number"
                                                    placeholder="Enter Customer Count"
                                                    value={formData.customers_count}
                                                    onChange={handleChange}
                                                    autoComplete="amount"
                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                />
                                               
                                            </div>
                                        </div>





                                    </div>
                                </div>
                                <div className="px-4 py-3 bg-white text-right sm:px-6">
                                    <button
                                        type="submit"
                                        className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div> */}

            <div className="flex items-center justify-end  w-full">
                <button
                    onClick={close}
                    className="text-gray-500 hover:text-gray-700 focus:outline-none"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="black"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"
                        ></path>
                    </svg>
                </button>
            </div>

            <div className='flex flex-col items-center mt-6  '>


                <div className="bg-blue-500 text-white p-3  rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40" color="#000000" fill="none">
                        <path d="M18.5 20V17.9704C18.5 16.7281 17.9407 15.5099 16.8103 14.9946C15.4315 14.3661 13.7779 14 12 14C10.2221 14 8.5685 14.3661 7.18968 14.9946C6.05927 15.5099 5.5 16.7281 5.5 17.9704V20" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <circle cx="12" cy="7.5" r="3.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
                    </svg>
                </div>
                <h1 className='text-3xl font-bold mt-4'>Add New Group</h1>

                <p className="text-gray-600 mt-2 text-center">
                    Complete the form below to add a new Group to your chit fund.
                    All fields marked with <span className="text-red-500">*</span> are required.
                </p>
            </div>
            <div className=' border-b-2 mt-4 '></div>

            <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 mt-4 gap-6">

                    {/* Name */}
                    <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
                            <span className='border bg-blue-100 rounded-full p-1'>

                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#bd10e0" fill="none">
                                    <path d="M18.5 20V17.9704C18.5 16.7281 17.9407 15.5099 16.8103 14.9946C15.4315 14.3661 13.7779 14 12 14C10.2221 14 8.5685 14.3661 7.18968 14.9946C6.05927 15.5099 5.5 16.7281 5.5 17.9704V20" stroke="#bd10e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <circle cx="12" cy="7.5" r="3.5" stroke="#bd10e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
                                </svg>
                            </span> Plan <span className='text-lg'> *</span>
                        </label>

                        <div className="mt-2">
                            <select
                                id="plan_id"
                                name="plan_id"
                                value={formData.plan_id}
                                onChange={handleChange}
                                autoComplete="plan_id"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            >
                                <option value={""}>Select Plan</option>
                                {plan?.map((type) => (
                                    <option key={type.id} value={type.id}>
                                        {type.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <p className="text-red-600 text-sm mt-1">
                            {validation.errors?.plan_id}
                        </p>
                    </div>

                    {/* Phone */}
                    <div>
                        <label htmlFor="phone"
                            className="block text-sm font-medium text-gray-700 flex items-center gap-2"
                        >

                            <span className='border bg-red-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#d0021b" fill="none">
                                    <path d="M15.5 11C15.5 9.067 13.933 7.5 12 7.5C10.067 7.5 8.5 9.067 8.5 11C8.5 12.933 10.067 14.5 12 14.5C13.933 14.5 15.5 12.933 15.5 11Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.4827 11.3499C15.8047 11.4475 16.1462 11.5 16.5 11.5C18.433 11.5 20 9.933 20 8C20 6.067 18.433 4.5 16.5 4.5C14.6851 4.5 13.1928 5.8814 13.0173 7.65013" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.9827 7.65013C10.8072 5.8814 9.31492 4.5 7.5 4.5C5.567 4.5 4 6.067 4 8C4 9.933 5.567 11.5 7.5 11.5C7.85381 11.5 8.19535 11.4475 8.51727 11.3499" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M22 16.5C22 13.7386 19.5376 11.5 16.5 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M17.5 19.5C17.5 16.7386 15.0376 14.5 12 14.5C8.96243 14.5 6.5 16.7386 6.5 19.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.5 11.5C4.46243 11.5 2 13.7386 2 16.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            Group Name {""}
                            <span className='text-lg'> *</span>
                        </label>
                        < input
                            id="group_name"
                            name="group_name"
                            type="text"
                            placeholder="Group Name"
                            value={formData.group_name}
                            onChange={handleChange}
                            autoComplete="amount"
                            className="block w-full rounded-md mt-2 border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                        <p className="text-red-600 text-sm mt-1">
                            {validation.errors?.group_name}
                        </p>
                    </div>

                    {/* Email */}
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
                            <span className='border bg-red-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#f5a623" fill="none">
                                    <path d="M15 8C15 5.23858 12.7614 3 10 3C7.23858 3 5 5.23858 5 8C5 10.7614 7.23858 13 10 13C12.7614 13 15 10.7614 15 8Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M17.5 21L17.5 14M14 17.5H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3 20C3 16.134 6.13401 13 10 13C11.4872 13 12.8662 13.4638 14 14.2547" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span> Customer Count
                        </label>
                        <input
                            id="customers_count"
                            name="customers_count"
                            type="number"
                            placeholder="Enter Customer Count"
                            value={formData.customers_count}
                            onChange={handleChange}
                            autoComplete="amount"
                            className="block w-full mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />

                    </div>






                </div>

                {/* Submit Button */}
                <div className="mt-6 text-right">
                    <button
                        type="submit"
                        className="inline-flex items-center gap-2 px-6 py-2 bg-[#0f172a] text-white text-sm font-medium rounded-md shadow hover:bg-teal-900 transition-all"
                    >
                        Save
                    </button>
                </div>
            </form>

        </div>
    )
}

export default GroupCreate
